import styled from "styled-components";

export const Container = styled.div`
  color: ${({ theme }) => theme.colors.redesign.db100};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  padding: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h2`
  margin: 0;
  ${props => ({ ...props.theme.font.link3 })};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.redesign.b10};
  padding: 4px 8px;
  color: ${({ theme }) => theme.colors.redesign.b100};
`;
